import './expo_page.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import { useTranslation } from 'react-i18next';

function Digitalservices() {
    const { t, i18n } = useTranslation();

    const navigate = useNavigate();

    return(

        <div className="main-wrapper">
            <div className="tools-wrapperS2">
                    <h1> {t('pages.digsev.ds1')}</h1>
                <div className="sez2" >
                    <div className="text-im">
                        {/* Eventuale descrizione finale */}
                        <p>{t('pages.digsev.ds2')}</p>
                        <p >{t('pages.digsev.ds3')}</p>
                            <ul className="text-im-list">
                            {/* Lista di paragrafi, evita i <br/> */}
                            {[t('pages.digsev.ds4'),t('pages.digsev.ds5'),t('pages.digsev.ds6'),
                            t('pages.digsev.ds7'),t('pages.digsev.ds8'),t('pages.digsev.ds9'),t('pages.digsev.ds10')].map((i) => (
                              <li key={i} className="text-im-paragraph">
                                {t(`${i}`)}
                              </li>
                            ))}
                            </ul>
                        
                     {/* Terzo blocco: Navigazione Bottone */}
                      <div className="pricing-button" onClick={() => navigate('/contatti')} style={{ cursor: 'pointer' }}>
                        <div className="ic1-block">
                                <h3 className="preview-title">{t('pages.vests.t18')}</h3>
                            </div>
                      </div>
                  </div>
                </div>
            </div>

 
        </div>

    );
}


export default Digitalservices;
